// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1SJhL","inputDescription":"styles_inputDescription__2gu-H"};